import { useEffect, useState } from "react";
import { loginSystemSetting } from "./CommonFunction";
import { PartiesOnPartyType } from "../../helpers/backend_helper";

/**
 * 🔹 Extract PartyTypeIDs from setting string
 */
const getPartyTypesFromSetting = (settingValue, currentPageId) => {
    if (!settingValue) return "";

    const mappings = settingValue.split("!");

    for (let item of mappings) {
        const [pagePart, partyTypes] = item.split("-");

        if (!pagePart || !partyTypes) continue;

        // ✅ SUPPORT MULTIPLE PAGE IDS (381,385)
        const pageIds = pagePart.split(",").map(p => Number(p.trim()));

        if (pageIds.includes(Number(currentPageId))) {
            return partyTypes;
        }
    }

    return "";
};

/**
 * 🔹 Hook to get party options based on setting + pageId
 */
const usePartyOptionsFromSetting = (settingKey, pageId) => {

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        const fetchData = async () => {
            try {
                setLoading(true);

                // ✅ Read dynamic setting (you can reuse for multiple settings)
                const settingValue = loginSystemSetting()?.[settingKey];

                const partyTypes = getPartyTypesFromSetting(settingValue, pageId);

                if (!partyTypes) {
                    setOptions([]);
                    return;
                }

                const res = await PartiesOnPartyType({
                    jsonBody: JSON.stringify({
                        PartyTypeID: partyTypes
                    })
                });

                if (res?.Status === true) {
                    const formatted = (res.Data || []).map(i => ({
                        value: i.id,
                        label: i.Name
                    }));

                    setOptions(formatted);
                }

            } catch (err) {
                console.error("Party Options Error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

    }, [settingKey, pageId]);

    return { options, loading };
};

export default usePartyOptionsFromSetting;